import { Box } from '@rbilabs/universal-components';

import Picture from 'components/picture';
import BlockRenderer from 'components/sanity-block-renderer';

export const Wrapper = Box.withConfig({
  alignItems: 'center',
  marginBottom: '24px',
});

export const StyledPicture = Picture.withConfig({
  maxWidth: '$64',
  marginBottom: '$4',
});

export const StyledText = BlockRenderer.withConfig({
  _text: {
    fontSize: 'sm',
  },
  textProps: {
    fontSize: 'sm',
  },
});
